import { Ionicons } from "@expo/vector-icons";
import { useCSSVariable } from "uniwind";
import {
  useFollowStatus,
  useToggleFollow,
} from "@/features/profile/api/followers";
import { useAuthContext } from "@/features/auth/hooks/use-auth-context";
import { posthog } from "@/shared/lib/posthog";
import { Pill } from "@/shared/components/ui/pill";

interface FollowButtonProps {
  userId: string;
}

export function FollowButton({ userId }: FollowButtonProps) {
  const { session } = useAuthContext();
  const { data: followStatus } = useFollowStatus(userId);
  const toggleFollow = useToggleFollow(userId);
  const primary = useCSSVariable("--color-primary") as string;
  const primaryForeground = useCSSVariable(
    "--color-primary-foreground"
  ) as string;
  const isOwnProfile = userId === session?.user.id;
  const isFollowing = followStatus?.isFollowing ?? false;

  if (isOwnProfile || !userId) return null;

  return (
    <Pill
      label={isFollowing ? "Seguindo" : "Seguir"}
      variant={isFollowing ? "ghost" : "solid"}
      tone={isFollowing ? "neutral" : "brand"}
      selected={isFollowing}
      leftIcon={
        <Ionicons
          name={isFollowing ? "checkmark" : "add"}
          size={16}
          color={isFollowing ? primary : primaryForeground}
        />
      }
      minWidth={130}
      accessibilityLabel={isFollowing ? "Deixar de seguir" : "Seguir"}
      onPress={() =>
        toggleFollow.mutate(isFollowing, {
          onSuccess: () => {
            posthog?.capture(
              isFollowing ? "user_unfollowed" : "user_followed",
              { target_user_id: userId }
            );
          },
        })
      }
    />
  );
}
